<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">DEDICATION</p>
<p class="s-txt">We dedicate this book to our mothers, fathers, grandmothers, and grandfathers, whose creativity, resourcefulness, and love of all things handmade inspired us to learn to sew.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_dedication.vue?69c8a448